import { ACCESS_LEVELS } from '@/lib/consts.js'

import { ACCESS_LEVEL_PERMISSION } from './const.js'

export default {
  [ACCESS_LEVEL_PERMISSION.allCalendars]: ({ accessLevel, overrides }) => {
    if ('calendar' in (overrides || {})
      && [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.RECEPTION].includes(accessLevel)
    ) {
      return overrides.calendar
    }
    return [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },

  [ACCESS_LEVEL_PERMISSION.clientDetails]: ({ accessLevel, overrides }) => {
    if ('client_info' in (overrides || {})
      && [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.RECEPTION].includes(accessLevel)
    ) {
      return overrides.client_info
    }
    return [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },

  [ACCESS_LEVEL_PERMISSION.checkout]: ({ accessLevel, overrides }) => {
    if ('checkout' in (overrides || {})
      && [ACCESS_LEVELS.STAFF].includes(accessLevel)
    ) {
      return overrides.checkout
    }
    return [ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.MANAGER, ACCESS_LEVELS.RECEPTION, ACCESS_LEVELS.OWNER].includes(accessLevel)
  },
}
